import reportStatus from '../../constants/all-report-status';
import DeviceStatus, { COMMS_STATES, DEVICE_STATES2, LockerStatus } from '../../constants/device-status';
import DeviceSettingStatus from '../../constants/device-setting-status';
import ActiveStatus from '../../constants/status/active-status';
import { SYSNAME_TEMPLATE } from '../../constants/preset-constants';
import { Translator } from '../../contexts/translator';

export const getReportStatus = (status) => {
    if (status === SYSNAME_TEMPLATE) {
        return reportStatus.Template.id;
    }

    return reportStatus.Custom.id;
}

export const getDeviceSettingStatus = (status) => {

    if (status === 1) {
        return DeviceSettingStatus.CustomSetting.id
    }
    else if (status === null) {
        return DeviceSettingStatus.Unknown.id;
    }

    return DeviceSettingStatus.InheritPreset.id;
}

/**
 * This method should only be used to interpret the commsStatus value stored against a
 * device in the database. I.e. the last recorded state of the device (online/offline).
 *
 * It must not be used to interpret websocket status.
 *
 * @param license
 * @param enabled
 * @param commsStatus
 */
export const getDeviceLicenceStatus = (license, enabled, commsStatus) => {

    // Unlicensed
    if (license === false) {
        return DeviceStatus.Unlicensed.id;
    }
    // Disabled
    else if (enabled == 0) {
        return DeviceStatus.Disabled.id;
    }
    else if (commsStatus != null) {
        // Offline
        if (commsStatus === COMMS_STATES.OFFLINE) {
            return DeviceStatus.Offline.id
        }
        // Online
        else if (commsStatus === COMMS_STATES.ONLINE_ICMP || commsStatus === COMMS_STATES.ONLINE_APP) {
            return DeviceStatus.Online.id;
        }
    }
    
    // Unknown
    return DeviceStatus.Unknown.id
}

/**
 * This method should only be used to interpret the commsStatus value stored against a
 * device in the database. I.e. the last recorded state of the device (online/offline).
 *
 * It must not be used to interpret websocket status.
 *
 * @param license
 * @param enabled
 * @param commsStatus
 */
export const getLockerStatusLbl = (lockerStatus, translate: Translator) => {

    // In Use
    if (lockerStatus == 1) {
        return translate.byKey(LockerStatus.InUse.translationKey) ?? LockerStatus.InUse.label;
    }
    
    // Available
    return translate.byKey(LockerStatus.Available.translationKey) ?? LockerStatus.Available.label;
}

/**
 * This method is used to interpret the status code we get from websockets for a specific device.
 * @param license
 * @param enabled
 * @param status
 */
export const getDeviceStatusWithLicense = (license, enabled, status) => {

    // Unlicensed
    if (license === false) {
        return DeviceStatus.Unlicensed.id;
    }
    // Disabled
    else if (enabled == 0) {
        return DeviceStatus.Disabled.id;
    }
    // Offline
    else if (status == null || status === DEVICE_STATES2.OFFLINE) {
        return DeviceStatus.Offline.id
    }
    // Online
    else if (status === DEVICE_STATES2.ONLINE_ICMP || status === DEVICE_STATES2.ONLINE_APP) {
        return DeviceStatus.Online.id;
    }
    // Busy / Uploading
    else if (status === DEVICE_STATES2.BUSY || status === DEVICE_STATES2.UPLOADING) {
        return DeviceStatus.BusyUploading.id;
    }

    return DeviceStatus.Unknown.id
}

/**
 * * Used for a table legend that only shows Active/Inactive states.
 * @param status 
 * @returns 
 */
export const getActiveStatus = (status: string | number) => {

    // Convert to string for comparison if it's a number
    const statusStr = typeof status === 'number' ? status.toString() : status;

    if (statusStr === ActiveStatus.Active.id) {
        return ActiveStatus.Active.id
    }

    return ActiveStatus.InActive.id;
}
